import { useEffect, useState } from "react";
import { getWorkspace } from "../api/workspaces";
import { useAuth } from "../context/AuthContext";

export default function useOperatorWorkspace(workspaceId) {
  const { token } = useAuth();
  const [workspace, setWorkspace] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token || !workspaceId) {
      setWorkspace(null);
      setLoading(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    setError("");

    getWorkspace(workspaceId, token)
      .then((row) => {
        if (active) {
          setWorkspace(row || null);
        }
      })
      .catch((err) => {
        if (active) {
          setError(err.message || "Unable to load workspace.");
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [token, workspaceId]);

  return {
    workspace,
    loading,
    error,
  };
}
